
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@mui/material'

import { withStyles } from '@material-ui/styles'
import styles from './agentsStyles'

const CallersList = ({ agentsList, classes }) => {

    const sortData = agentsList.sort((a, b) => {
        if (!a.ui_login && b.ui_login) return 1
        if (a.ui_login && !b.ui_login) return -1

        const dateA = new Date(a.ui_login)
        const dateB = new Date(b.ui_login)

        return dateA - dateB
    })

    return (
        <Grid className={classes.hrzntlTabLyt}>
            <TableContainer>
                <Table sx={{ minWidth: 36 }} aria-label="simple table">
                    <TableHead>
                        <TableRow style={{ borderBottom: '2px solid Black' }}>
                            <TableCell
                                className={classes.tbleHeadTxt}
                                align="left"><strong>Agent ID</strong></TableCell>
                            <TableCell align="left" className={classes.tbleHeadTxt}><strong>Name</strong></TableCell>
                            <TableCell align="left" className={classes.tbleHeadTxt}><strong>Email</strong></TableCell>
                            <TableCell align="left" className={classes.tbleHeadTxt}><strong>Logged In</strong></TableCell>
                            <TableCell align="left" className={classes.tbleHeadTxt}><strong>Presence</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {sortData.map((row, i) => (
                            <TableRow key={i} style={{ borderBottom: '2px solid Black' }}>
                                <TableCell align="left" className={classes.rowText}>{row.sip_id}</TableCell>
                                <TableCell align="left" className={classes.rowText}>{row.name.charAt(0).toUpperCase() + row.name.slice(1)}</TableCell>
                                <TableCell align="left" className={classes.rowText}>{row.email}</TableCell>
                                <TableCell align="left" className={classes.rowText}>{row.ui_login?.split('.')[0]}</TableCell>
                                <TableCell align="left" className={classes.rowText}>{row.presence}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}

export default withStyles(styles)(CallersList)